var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import Header from './component/AddHeader.vue';
import ELogisticsType from "../../enum/ELogisticsType";
import EQuotedPriceType from '../../enum/EQuotedPriceType';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { Watch } from 'vue-property-decorator';
import { summaries } from '../../helper/util';
import { numAdd, numSub, numMulti, numDiv } from '../../helper/calucate';
import QuotedPrice from '../../api/QuotedPrice';
import EntrustDeliverService from '../../api/EntrustDeliverService';
import GoodsStockService from '../../api/GoodsStockService';
import BasicArcheivesService from '../../api/BasicArcheivesService';
import GLOBAL_VUE from '../../globalVue';
import _ from 'lodash';
import { Loading } from 'element-ui';
import { auth } from '../../helper/authDecorator';
import { nameDict } from '../../constant/authCode';
import { mapGetters } from 'vuex';
import EOrderFromSystem from '../../enum/EOrderFromSystem';
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import CommonService from '../../api/CommonService';
import MulOrderDetailOamount from './component/MulOrderDetailOamount.vue';
import DistriDialog from './component/DistributionDialog.vue';
import SeeBindLicenses from '../good/SeeBindLicenses';
import ArticleList from "../../components/alert/ArticleList.vue";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import Client from '../client/List.vue';
import Purchase from '../purchase/List.vue';
import { BigNumber } from "bignumber.js";
import SelectStockBatch from './component/SelectStockBatch';
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["SAVE"] = 1] = "SAVE";
    ESaveType[ESaveType["SAVE_PRINT"] = 2] = "SAVE_PRINT";
})(ESaveType || (ESaveType = {}));
export var EOrderType;
(function (EOrderType) {
    EOrderType[EOrderType["ORDER"] = 0] = "ORDER";
    EOrderType[EOrderType["NO_ORDER"] = 1] = "NO_ORDER";
    EOrderType[EOrderType["RETAIL"] = 2] = "RETAIL";
})(EOrderType || (EOrderType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderFromSystem = EOrderFromSystem;
        _this.eLogisticsType = ELogisticsType;
        _this.orderHasMerge = false;
        _this.loadingOutDepotOptions = false;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.data = [];
        _this.formData = {
            from_system: '',
            order_type: '',
            business_id: '',
            shop_id: undefined,
            organ_id: '',
            out_depot_id: '',
            depot_id: '',
            depot_name: '',
            expect_arrivedate: '',
            reciever_phone: '',
            deliverer_id: '',
            deliverer_phone: '',
            delivery_plate_number: '',
            delivery_time: '',
            order_icomment: '',
            delivery_order_code: '',
            order_type_name: '',
            purchase_order_order: [],
            organ_name: '',
            shop_name: '',
            out_depot_name: '',
            sorting_order: [],
            customer: '',
            poo_last_ctime: '',
            is_modify_oamount: 1,
            is_modify_uprice: 1,
            is_show_uprice: 1,
            reciever_address: '',
            logistics_number: ''
        };
        _this.otherData = {
            outStoreList: [],
        };
        _this.enumType = EQuotedPriceType;
        _this.enumStatus = EHandleStatus;
        _this.ESaveType = ESaveType;
        _this.EOrderType = EOrderType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.dialogTableVisible = false;
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.emptyMoneyCanSubmit = false;
        _this.notAllEmptyFlag = true;
        _this.emptyFlag = true;
        _this.goods_ids = [];
        _this.goodsTableData = [];
        _this.mulShopList = [];
        _this.mulOrderDetailRowData = {};
        _this.currentGood = {};
        _this.changeDepotmodalShow = false;
        _this.depotList = [];
        _this.changeDepotId = '';
        _this.shipData = '';
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.watchOrderType = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodsTableData = [];
    };
    default_1.prototype.watchshop_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodsTableData = [];
    };
    default_1.prototype.watchorgan_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            this.goodsTableData = [];
        }
        else {
            this.otherData.outStoreList = [];
            return;
        }
    };
    default_1.prototype.watchout_depot_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodsTableData = [];
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.service = QuotedPrice.getInstance();
        this.EntrustDeliverService = EntrustDeliverService.getInstance();
        this.goodsStockService = GoodsStockService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        if (this.handleStatus === EHandleStatus.Edit) {
            this.getEditOrderInfo();
        }
    };
    default_1.prototype.saveAndAudit = function () {
        var _this = this;
        this.$confirm('确定保存并审核吗？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                console.log("确定保存并审核");
                _this.updateDeliveryOrder(1);
            }
        }).catch(function () { });
    };
    default_1.prototype.changeDepotmodalConfirm = function () {
        var _this = this;
        if (!this.changeDepotId)
            return this.$message.warning("请选择出库仓库");
        this.selections.map(function (item) {
            var index = _this.goodsTableData.indexOf(item);
            GLOBAL_VUE.$set(_this.goodsTableData[index], 'outDepotOptions', _this.depotList);
            GLOBAL_VUE.$set(_this.goodsTableData[index], 'out_depot_id', _this.changeDepotId);
        });
        this.changeDepotmodalHide();
        this.$refs.Table.clearSelection();
    };
    default_1.prototype.changeDepot = function () {
        if (!this.formData.organ_id)
            return this.$message.warning("请选择出库机构");
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请先选择货品");
            return;
        }
        this.getDepotList();
        this.changeDepotmodalShow = true;
    };
    default_1.prototype.getDepotList = function () {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: this.formData.organ_id
        };
        this.commonService.getDepotList(params).then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.depotList = data;
        });
    };
    default_1.prototype.changeDepotmodalHide = function () {
        this.changeDepotmodalShow = false;
        this.changeDepotId = '';
    };
    default_1.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row);
    };
    default_1.prototype.batchSubmit = function (row) {
        if (row.batch_list.length) {
            var order_detail_oamount_1 = 0;
            row.batch_list.map(function (item) {
                order_detail_oamount_1 = order_detail_oamount_1 + item.order_detail_oamount;
            });
            row.order_detail_oamount = order_detail_oamount_1.toFixedNoZero(4);
        }
        else {
            row.order_detail_oamount = row.old_order_detail_oamount || 0;
        }
    };
    default_1.prototype.calc_stock = function (row) {
        return "" + row.order_remaining_stock + row.inventory_unit;
    };
    default_1.prototype.calc_deliveryVolume = function (row) {
        return numMulti(row.order_detail_oamount, row.sales_unit_coefficient).toFixedNoZero(4);
    };
    default_1.prototype.calc_amountIncludingTaxscope = function (row, type) {
        var key = this.formData.vir_through_is_show_uprice == 0 ? 'pood_uprice' : 'order_detail_uprice';
        return (row[type] = numMulti(row.order_detail_oamount, row[key]).toFixedNoZero(2));
    };
    default_1.prototype.calc_taxAmount = function (row, type) {
        if (row.order_detail_tax_rate === 0) {
            return (row[type] = 0);
        }
        var firArg = numMulti(row.order_detail_oamount, row.order_detail_uprice);
        var secArg = numAdd(1, row.order_detail_tax_rate);
        return (row[type] = numMulti(numDiv(firArg, secArg), row.order_detail_tax_rate).toFixedNoZero(4));
    };
    default_1.prototype.calc_amountOfMoney = function (row, type) {
        var amountIncludingTaxs = numMulti(row.order_detail_oamount, row.order_detail_uprice);
        if (row.order_detail_tax_rate === 0) {
            amountIncludingTaxs.toFixedNoZero(4);
        }
        var taxRateAmount = numDiv(amountIncludingTaxs, numAdd(1, row.order_detail_tax_rate));
        var taxAmount = numMulti(taxRateAmount, row.order_detail_tax_rate);
        return (row[type] = numSub(amountIncludingTaxs, taxAmount).toFixedNoZero(4));
    };
    default_1.prototype.dealManyShopAmount = function (row, index) {
        var _this = this;
        this.mul_goods_format_index = index;
        this.mulOrderDetailRowData = JSON.parse(JSON.stringify(row));
        this.mulShopList = JSON.parse(JSON.stringify(row.items));
        this.$nextTick(function () {
            _this.$refs.mulShop.showRelease();
        });
    };
    default_1.prototype.orderDetailOamountSave = function (data) {
        if (!data.length) {
            return;
        }
        var amount = 0;
        data.forEach(function (item) {
            amount = numAdd(amount, item.order_detail_oamount);
        });
        this.goodsTableData[this.mul_goods_format_index].items = data;
        this.goodsTableData[this.mul_goods_format_index].order_detail_oamount = amount;
    };
    default_1.prototype.pageChange = function (pager) {
    };
    default_1.prototype.blur_priceAndamount = function (data, name) {
        if (data[name] == '') {
            data[name] = 0;
        }
    };
    default_1.prototype.myFixed = function (num, digit) {
        return BigNumber(num).toFixed(digit);
    };
    default_1.prototype.inputChange = function (row, attr1, attr2) {
        if (attr1 === 'order_detail_oamount' && row[attr1]) {
            var pointIndex = String(row[attr1]).indexOf('.');
            if (pointIndex > -1) {
                row[attr1] = String(row[attr1]).slice(0, pointIndex + Number(this.amountScale) + 1);
            }
        }
        else if (row[attr1]) {
            row[attr1] = String(row[attr1]).replace(/^(.*\..{4}).*$/, "$1");
        }
        var 金额字段 = this.formData.vir_through_is_show_uprice == 0 ? 'pood_uprice' : 'order_detail_uprice';
        if ([金额字段, 'order_detail_oamount'].includes(attr1)) {
            row.batch_list = [];
            if ((parseFloat(row[金额字段]) || parseFloat(row.order_detail_goods_money))) {
                if (parseFloat(row[金额字段])) {
                    row['order_detail_goods_money'] = new Number(_.multiply(row.order_detail_oamount, row[金额字段])).toFixedNoZero(2);
                    row['order_detail_goods_money_real'] = new Number(_.multiply(row.order_detail_oamount, row[金额字段])).toFixedNoZero(4);
                    row['order_detail_money'] = numSub(_.multiply(row.order_detail_oamount, row[金额字段]), row.order_detail_reduction_money).toFixedNoZero(2);
                    row['order_detail_money_real'] = numSub(_.multiply(row.order_detail_oamount, row[金额字段]), row.order_detail_reduction_money).toFixedNoZero(4);
                }
            }
        }
        if ('order_detail_money' == attr1 && parseFloat(row.order_detail_money)) {
            row[金额字段] = new Number(_.divide(row.order_detail_money, row.order_detail_oamount)).toFixedNoZero(4);
        }
        if (attr2) {
            if (row[attr1][attr2] < 0) {
                row[attr1][attr2] = Math.abs(row[attr1][attr2]);
            }
        }
        else {
            if (row[attr1] < 0) {
                row[attr1] = Math.abs(row[attr1]);
            }
        }
    };
    default_1.prototype.outDepotChange = function (row) {
        var _this = this;
        row.batch_list = [];
        if (this.openedCodeData && this.openedCodeData.isOpenERP) {
            var params = {
                depot_id: row.out_depot_id,
                goods_format_id: row.goods_format_id,
            };
            return this.goodsStockService
                .getDepotGoodsFormatStock(params)
                .then(function (res) {
                var data = res.data.data;
                row.order_remaining_stock = data.order_remaining_stock;
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    default_1.prototype.initEditOrderData = function (data) {
        this.orderHasMerge = data.logistics_type == this.eLogisticsType.Straight || data.logistics_type == this.eLogisticsType.VirtualStraight || (data.logistics_type == this.eLogisticsType.Direct && data.depot_in_type == 1);
        this.formData = {
            from_system: data.from_system,
            order_type: data.order_type,
            business_id: data.business_id,
            shop_id: data.shop_id,
            organ_id: data.organ_id,
            out_depot_id: data.out_depot_id,
            depot_id: data.depot_id,
            depot_name: data.depot_name,
            expect_arrivedate: data.expect_arrivedate,
            reciever_phone: data.reciever_phone,
            deliverer_id: data.deliverer_id,
            deliverer_phone: data.deliverer_phone || '',
            delivery_plate_number: data.delivery_plate_number || '',
            delivery_time: data.delivery_time,
            order_icomment: data.order_icomment,
            delivery_order_code: data.delivery_order_code,
            order_type_name: data.order_type_name,
            purchase_order_order: data.purchase_order_order,
            organ_name: data.organ_name,
            shop_name: data.shop_name,
            out_depot_name: data.out_depot_name,
            sorting_order: data.sorting_order,
            customer: data.customer,
            delivery_order_status: data.delivery_order_status,
            poo_last_ctime: data.poo_last_ctime,
            is_modify_oamount: data.is_modify_oamount,
            is_modify_uprice: data.is_modify_uprice,
            is_show_uprice: data.is_show_uprice,
            logistics_type: data.logistics_type,
            reciever_address: data.reciever_address,
            vir_through_is_show_uprice: data.vir_through_is_show_uprice,
            logistics_number: data.logistics_number,
            is_split_order: data.is_split_order
        };
        this.goodsTableData = data.detail;
        this.initOutDepotOptions();
    };
    default_1.prototype.getEditOrderInfo = function () {
        var _this = this;
        if (this.shipData) {
            this.initEditOrderData(this.shipData);
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.EntrustDeliverService
            .getEditOrderInfo({
            order_id: this.order_id,
        })
            .then(function (res) {
            var data = res.data.data;
            _this.initEditOrderData(data);
            loadingInstance.close();
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.initOutDepotOptions = function () {
        var _this = this;
        this.goodsTableData.forEach(function (row) {
            row.out_depot_id = row.out_depot_id == 0 ? '' : row.out_depot_id;
            _this.getOutDepotOptionsOneOrZero(row);
        });
    };
    default_1.prototype.filterSearch = function (val, row) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getOutDepotOptions(val, row);
        }, 500);
    };
    default_1.prototype.focusOutDepotId = function (event, row) {
        this.getOutDepotOptions('', row);
    };
    default_1.prototype.getOutDepotOptions = function (val, row) {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: row.out_organ_id,
        };
        this.loadingOutDepotOptions = true;
        this.commonService
            .getDepotList(params)
            .then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                var index = _this.goodsTableData.indexOf(row);
                GLOBAL_VUE.$set(_this.goodsTableData[index], 'outDepotOptions', data);
            }
            _this.loadingOutDepotOptions = false;
        })
            .catch(function () {
            _this.loadingOutDepotOptions = false;
        });
    };
    default_1.prototype.getOutDepotOptionsOneOrZero = function (row, trigger) {
        var data = [];
        if (row.out_depot_id) {
            data.push({
                depot_id: row.out_depot_id,
                depot_name: row.out_depot_name,
            });
        }
        var index = this.goodsTableData.indexOf(row);
        GLOBAL_VUE.$set(this.goodsTableData[index], 'outDepotOptions', data);
    };
    default_1.prototype.save = function (status) {
        if (this.handleStatus === EHandleStatus.Edit) {
            this.updateDeliveryOrder(status);
        }
        else {
            this.addDeliveryOrder();
        }
    };
    default_1.prototype.updateDeliveryOrder = function (status) {
        var _this = this;
        var params = {
            delivery_order_id: this.order_id,
            organ_id: this.formData.organ_id,
            out_depot_id: this.formData.out_depot_id,
            expect_arrivedate: moment(this.formData.expect_arrivedate).format('YYYY-MM-DD'),
            reciever_phone: this.formData.reciever_phone,
            reciever_address: this.formData.reciever_address,
            logistics_number: this.formData.logistics_number,
            deliverer_id: this.formData.deliverer_id,
            deliverer_phone: this.formData.deliverer_phone,
            delivery_plate_number: this.formData.delivery_plate_number,
            delivery_time: this.formData.delivery_time
                ? moment(this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                : '',
            order_icomment: this.formData.order_icomment,
            delivery_order_status: status,
            data: JSON.stringify(this.goodsTableData),
        };
        var bindUpdateOrderAjax = function (params) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.EntrustDeliverService.updateDeliveryOrder(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code === 67) {
                    var text = res.data.msg;
                    _this.$confirm('提示', {
                        title: '提示',
                        message: text,
                        confirmButtonText: "是",
                        cancelButtonText: "否",
                        type: "success",
                        showClose: false,
                    }).then(function (res) {
                        if (res) {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 1 }));
                        }
                    }).catch(function (action) {
                        if (action === "cancel") {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 0 }));
                        }
                    });
                    return;
                }
                if (res.data.code == 0) {
                    _this.$message.success('操作成功');
                    setTimeout(function () {
                        GLOBAL_VUE.$emit('closeTab', _this);
                        _this.opener.fetch();
                    }, 500);
                    return;
                }
                if (res.data.code === 54) {
                    var instance_1 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_1.$on('artMsglist:ok', function (data) {
                        var confirm = res.data.data[0].confirm;
                        bindUpdateOrderAjax(__assign({}, params, { confirm: confirm }));
                    });
                    return;
                }
                if (res.data.code === 17) {
                    var instance_2 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                            txtColor: "#FF2605"
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_2.$on('artMsglist:ok', function (data) {
                        bindUpdateOrderAjax(__assign({}, params, { stock_confirm: 1 }));
                    });
                    return;
                }
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getEditOrderInfo();
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'deliver'
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on('addClient:ok', function (data) {
                    if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                        _this.addTab({
                            component: Client,
                            title: '合作客户',
                            name: '合作客户'
                        });
                    }
                    if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                        _this.addTab({
                            component: Purchase,
                            title: '采购入库',
                            name: '采购入库'
                        });
                    }
                });
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
        };
        bindUpdateOrderAjax(params);
    };
    default_1.prototype.addDeliveryOrder = function () {
        var _this = this;
        try {
            this.validateSaveDeliver(this.formData);
            if (!this.goodsTableData.length) {
                throw new Error('货品信息不能为空');
            }
            for (var i = 0; i < this.goodsTableData.length; i++) {
                if (parseFloat(this.goodsTableData[i].order_detail_uprice) == 0) {
                    throw new Error('单价不能为 0');
                    break;
                }
            }
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_type: this.formData.order_type,
            business_id: this.formData.business_id,
            shop_id: this.formData.shop_id,
            organ_id: this.formData.organ_id,
            out_depot_id: this.formData.out_depot_id,
            depot_id: this.formData.depot_id,
            depot_name: this.formData.depot_name,
            expect_arrivedate: moment(this.formData.expect_arrivedate).format('YYYY-MM-DD'),
            reciever_phone: this.formData.reciever_phone,
            reciever_address: this.formData.reciever_address,
            logistics_number: this.formData.logistics_number,
            deliverer_id: this.formData.deliverer_id,
            deliverer_phone: this.formData.deliverer_phone,
            delivery_plate_number: this.formData.delivery_plate_number,
            delivery_time: this.formData.delivery_time
                ? moment(this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                : '',
            order_icomment: this.formData.order_icomment,
            delivery_order_status: 0,
            data: JSON.stringify(this.goodsTableData),
        };
        return this.EntrustDeliverService
            .addDeliveryOrder(params)
            .then(function (res) {
            _this.$message.success('保存成功');
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                _this.opener.fetch();
            }, 500);
            loadingInstance.close();
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.getSelectIds = function () {
        var orderIds = this.selections.map(function (item) {
            return item.order_id;
        });
        return orderIds;
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ['order_detail_money', 'order_detail_tax_money', 'money'];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        return sums;
    };
    default_1.prototype.addGoods = function () {
        var _this = this;
        try {
            this.validateAddGood(this.formData);
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var goodIds = [];
        this.goodsTableData.forEach(function (item) {
            if (_this.formData.order_type == EOrderType.NO_ORDER) {
                goodIds.push(item.goods_format_id);
            }
            else if (_this.formData.order_type == EOrderType.RETAIL) {
                goodIds.push(item.goods_format_id);
            }
        });
        var instance = this.$dialog(DistriDialog, {
            data: {
                supplier_upper_id: 1,
                formData: this.formData,
                openedCodeData: this.openedCodeData,
                selectedGoodIds: goodIds,
            },
        }, {
            title: '添加货品',
            width: 750,
            height: 650,
        }).instance;
        instance.$on('save:ok', function (selectGood) {
            if (selectGood.length) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var goods_ids = selectGood.map(function (item) { return item.supplier_goods_id; });
                _this.basicArcheivesService.getDepotId({
                    organ_id: _this.formData.organ_id,
                    shop_id: _this.formData.shop_id,
                    goods_ids: goods_ids.join(',')
                }).then(function (res) {
                    loadingInstance_1.close();
                    var data = res.data.data;
                    var ruleOutDepotIds = data && data.goods_depot_map;
                    selectGood.forEach(function (item) {
                        item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                        var ruleOutDepotId = ruleOutDepotIds[item.supplier_goods_id];
                        if (ruleOutDepotId && ruleOutDepotId.depot_id) {
                            item.out_depot_id = ruleOutDepotId.depot_id;
                            item.out_depot_name = ruleOutDepotId.depot_name;
                        }
                        _this.goodsTableData.push(item);
                        _this.getOutDepotOptionsOneOrZero(item);
                    });
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                    loadingInstance_1.close();
                });
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.goodsTableData.indexOf(item);
                _this.goodsTableData.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.validateSaveDeliver = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.organ_id && data.organ_id !== 0) {
            throw new Error('请选择出库机构');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('出库机构没有设置默认仓库');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
        if (!data.expect_arrivedate) {
            throw new Error('请选择预计收货时间');
            return;
        }
    };
    default_1.prototype.validateAddGood = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('出库机构没有设置默认仓库');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
    };
    default_1.prototype.seeBindLicenses = function (row) {
        GLOBAL_VUE.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看绑定证照',
            showExist: true,
            name: 'goods-see-bind-license' +
                row.supplier_goods_id +
                'goods_format_id' +
                row.goods_format_id +
                'order_id' +
                this.order_id +
                'order_detail_id' +
                row.order_detail_id,
            cprops: {
                from_page: 'deliver',
                order_id: this.order_id,
                order_detail_id: row.order_detail_id,
                goods_id: row.supplier_goods_id,
                goods_name: row.supplier_goods_name,
                goods_code: row.supplier_goods_code,
                goods_format_id: row.goods_format_id,
                goods_format_name: row.supplier_goods_format,
                delivery_order_status: this.formData.delivery_order_status
            },
        });
    };
    default_1.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GLOBAL_VUE.$emit('addTab', options);
    };
    default_1.prototype.splitNote = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品后再进行拆分');
            return;
        }
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426\u5C06\u9009\u4E2D\u8D27\u54C1\u751F\u6210\u65B0\u7684\u9001\u8D27\u5355\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
        }).then(function (res) {
            if (res) {
                var params = {
                    order_id: _this.order_id,
                    delivery_order_id: _this.order_id,
                    organ_id: _this.formData.organ_id,
                    out_depot_id: _this.formData.out_depot_id,
                    expect_arrivedate: _this.formData.expect_arrivedate ? moment(_this.formData.expect_arrivedate).format('YYYY-MM-DD') : _this.formData.expect_arrivedate,
                    reciever_phone: _this.formData.reciever_phone,
                    deliverer_id: _this.formData.deliverer_id,
                    delivery_time: _this.formData.delivery_time
                        ? moment(_this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    order_icomment: _this.formData.order_icomment,
                    data: JSON.stringify(_this.selections),
                };
                var loadingInstance_2 = Loading.service({ fullscreen: true });
                _this.EntrustDeliverService
                    .splitEntrustedDeliveryOrder(params)
                    .then(function (res) {
                    loadingInstance_2.close();
                    if (res.data.code == 0) {
                        _this.$message.success('操作成功');
                        var timer_1 = setTimeout(function () {
                            clearTimeout(timer_1);
                            GLOBAL_VUE.$emit('closeTab', _this);
                            _this.opener.fetch();
                        }, 500);
                        return;
                    }
                })
                    .catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                    loadingInstance_2.close();
                });
            }
        });
    };
    __decorate([
        Watch('formData.order_type')
    ], default_1.prototype, "watchOrderType", null);
    __decorate([
        Watch('formData.shop_id')
    ], default_1.prototype, "watchshop_id", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchorgan_id", null);
    __decorate([
        Watch('formData.out_depot_id')
    ], default_1.prototype, "watchout_depot_id", null);
    default_1 = __decorate([
        auth(nameDict['送货单'], true),
        Component({
            components: {
                'add-header': Header,
                'mul-order-detail-oamount': MulOrderDetailOamount,
                'select-stock-batch': SelectStockBatch,
            },
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus',
                canSelectBatch: 'canSelectBatch',
            }), { through_is_show_uprice: function () {
                    var isVirtualStraight = [5].includes(this.formData.logistics_type);
                    return (isVirtualStraight && this.formData.vir_through_is_show_uprice == 1 && this.handleStatus === EHanldeStatus.Edit);
                },
                amountScale: function () {
                    return this.$store.getters.getBusinessConfig(this.formData.business_id, 'amount_scale', '4');
                } }),
            methods: {
                采购单价与含税金额可编辑: function (row) {
                    var isVirtualStraight = [5].includes(this.formData.logistics_type);
                    var 虚拟直通送货单是否展示送货单价 = this.formData.vir_through_is_show_uprice;
                    var 允许修改不定价货品价格 = (row || {}).is_modify_uprice;
                    return this.handleStatus === EHanldeStatus.Edit && isVirtualStraight && 虚拟直通送货单是否展示送货单价 == 0 && 允许修改不定价货品价格 == 1;
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
